import { BuyDeliveryNoteProductTypeModelType } from '@teinor/erp/types/company/order/buy/buyDeliveryNote/buyDeliveryNoteProductType';
import { BuyInvoiceProductTypeModelType } from '@teinor/erp/types/company/order/buy/buyInvoice/buyInvoiceProductType';
import { BuyOrderProductTypeModelType } from '@teinor/erp/types/company/order/buy/buyOrder/buyOrderProductType';
import { OrderProductType } from './types';

export const parseOrderProductTypes = (OrderProductTypes: BuyOrderProductTypeModelType[] | BuyDeliveryNoteProductTypeModelType[] | BuyInvoiceProductTypeModelType[]) => {
    const result: OrderProductType =  { productTypes: [], ids: []}
    for (const productType of OrderProductTypes) {
        result.productTypes.push(productType)
        result.ids.push(productType.ProductTypeId)
    }
    return result
}